<section class="fancy-h2" [class.fancy-h2--centered]="isCentered" *ngIf="title || lead || link">
  <div class="container">
    <h2 *ngIf="title">{{ title }}</h2>
    <p *ngIf="lead" [innerHTML]="lead"></p>
    <a [href]="link" *ngIf="link">{{ linkText }}</a>
  </div>
</section>
